import React from 'react';
import styled from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';

import Picture from '@/components/Picture';
import {
  DetailedCarGalleryImageItem,
  VerticalSliderProps,
} from '@/components/DetailedCarGallery/DetailedCarGallery.types';
import { colors } from '@/constants/theme';

function VerticalSlider({
  images,
  currentSlideIndex,
  setCurrentSlideIndex,
}: VerticalSliderProps) {
  return (
    <Component>
      <Swiper
        direction={'vertical'}
        loop={true}
        initialSlide={currentSlideIndex - 1}
        slidesPerView={3}
        spaceBetween={10}
        centeredSlides={true}
        onSlideChange={(swiper) => {
          setCurrentSlideIndex(swiper.activeIndex - 2);
        }}
      >
        {images.map((item: DetailedCarGalleryImageItem, index) => (
          <SwiperSlide key={index}>
            <StyledPicture
              index={index}
              current={currentSlideIndex}
              mobileLarge={{ src: item.mobile }}
              mobileSmall={{ src: item.mobile }}
              loading="lazy"
            />
            <SlideCounter>
              {index + 1} / {images.length}
            </SlideCounter>
          </SwiperSlide>
        ))}
      </Swiper>
    </Component>
  );
}

const SlideCounter = styled.div`
  position: absolute;
  display: inline-flex;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  left: 2px;
  bottom: 2px;
  padding: 1.5px 8px;
  border-radius: 4px;
  background: rgba(21, 27, 38, 0.8);
  color: ${colors.gray200};
`;

const Component = styled.div`
  position: relative;
  height: calc(100vh - 40px);

  .swiper-container {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .swiper-slide {
    &:before {
      z-index: 2;
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        0deg,
        rgba(21, 27, 38, 0.6),
        rgba(21, 27, 38, 0.6)
      );
    }

    ${SlideCounter} {
      display: none;
    }

    &-active {
      &:before {
        display: none;
      }

      ${SlideCounter} {
        display: inline-flex;
      }
    }
  }
`;

const StyledPicture = styled(Picture)<{ index?: number; current?: number }>`
  position: absolute;
  width: 100%;
  height: 100%;

  picture,
  img {
    width: 100%;
    height: 100%;
  }

  img {
    object-fit: cover;
  }
`;

export default VerticalSlider;
